// ─────────────────────────────────────────────────────────────────────────────
// WHICH ARRIVING NOTIFICATIONS ARE SPOKEN, AND WHICH MAY BE CLEARED.
//
// RE-TEST ITEM 24 (Carla, 2026-09-23): she made a booking and the notice never
// appeared under "Needs a decision" — "Not cleared by chat: never there."
//
// The census settled it: the row WAS created (booking_received, priority high,
// valid workspace, one second after the booking) and was then dismissed. The
// backend half had already been fixed — chat no longer auto-READS a
// high-priority notice — but this, the frontend delivery router, was a SECOND
// route to the same outcome, and a worse one: it set DISMISSED, which removes
// the notice from the list entirely rather than merely marking it seen.
//
// Her rule, unchanged: "An urgent or high-priority notice must never be
// dismissed because chat mentioned it. It stays under 'Needs a decision' until I
// have acted on it. Chat may surface it; only my action clears it."
//
// So: urgent and high are still delivered conversationally, and are NEVER
// cleared here. Only low-priority notices — the ones folded into the next
// briefing — may be cleared without her.
// ─────────────────────────────────────────────────────────────────────────────

const SPOKEN = ['urgent', 'high'];

export function routeNotifications(arriving = []) {
  const urgent = arriving.filter(n => SPOKEN.includes(n.priority));
  const normal = arriving.filter(n => n.priority === 'normal');
  const low    = arriving.filter(n => !SPOKEN.includes(n.priority) && n.priority !== 'normal');
  return {
    urgent,
    normal,
    low,
    // The ONLY ids this router may clear. Urgent and high are deliberately
    // absent: speaking a thing is not acting on it.
    dismissIds: low.map(n => n.id),
  };
}

export { SPOKEN as SPOKEN_PRIORITIES };
